import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountResponse } from '../core/models/account-response';
import { environment } from "environments/environment";
import { Organization } from "app/core/interfaces/organization.interface";

@Injectable()
export class OrganizationService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getOrganizations({ sortDirection, sortField, pageIndex, pageSize, activeFilters }: { filter: string; sortDirection: 'asc' | 'desc' | ''; sortField: string; pageIndex: number; pageSize: number; activeFilters: unknown[]; }): Observable<AccountResponse> {
    
    const allStringFilterAux = [];
    activeFilters.forEach((item) => {
        if (item['value'] != null && item['value'] != '') {
            const stringFilterAux = [item['id'],item['value']];
            allStringFilterAux.push(stringFilterAux.join('::'));
        }
    });

    const queryFilter = allStringFilterAux.join('--');

    
    const params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/organizations`, {
      params: params
      }).pipe(
          
          map(res =>  <AccountResponse>res)
      );    
    
  }


  getOrganizationStatus(): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/organizations/status`);
}

getOrganizationTypes(): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/organizations/types`);
}

getOrganization(id: string): Observable < any > {
  return this._httpClient.get(`${environment.apiUrl}/organizations/${id}`);
}

getOrganizationForensicCredentials(id: string): Observable < any > {
  return this._httpClient.get(`${environment.apiUrl}/organizations/${id}/forensic_credentials`);
}

editOrganizationForensicCredentials(credentials: any, id: string): Observable < any > {
  return this._httpClient.put(`${environment.apiUrl}/organizations/${id}/forensic_credentials`, credentials);
}

getOrganizationForensicStatistics(id: string): Observable < any > {
  return this._httpClient.get(`${environment.apiUrl}/organizations/${id}/forensic_statistics`);
}

deleteOrganization(id: string): Observable < any > {
  return this._httpClient.delete(`${environment.apiUrl}/organizations/${id}`);
}

editOrganization(organization: Organization, id: string): Observable < any > {
  return this._httpClient.put(`${environment.apiUrl}/organizations/${id}`, organization);
}

createOrganization(organization: Organization): Observable < any > {
  return this._httpClient.post(`${environment.apiUrl}/organizations`, organization);
}
  
}
